import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import ListViewCpt from '@/components/list/ListViewCpt';
import cptCmn from '@/mixin/cpt-cmn';
import { rqtGetCustomeInvestRecordInfo } from '@/services/cms/customer';
export default {
  mixins: [cptCmn],
  components: {
    PageNavBackLayoutCpt,
    ListViewCpt
  },
  data() {
    return {
      searchForm: {
        id: ''
      },
      listRequest: rqtGetCustomeInvestRecordInfo,
      codeResItems: [{
        title: ' 拜访类型',
        dataIndex: 'visitType',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'customerVisitType'
      }, {
        title: '拜访动作',
        dataIndex: 'visitAction',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'customerVisitAction'
      }]
    };
  },
  created() {
    let customerId = this.$route.params && this.$route.params.customerId;
    if (customerId) {
      this.searchForm.id = customerId;
      this.initResCodeType(this.codeResItems);
    }
  }
};